import React from '../services/React';
import UI from '../services/UI';
import TimeRanges from './TimeRanges';
import TextInput from './TextInput';
import { openBillingPage, isPremium } from '../../commons/services/Wix';

function OpeningHours({ onNoteChange, onTimerangesChange, timeranges, note }) {
  return (
    <div>
      <hr className="divider-long" />
      <UI.sectionDividerLabeled label="Text" />
      <hr className="divider-long" />

      <div className="OpeningHours__Note">
        {!isPremium()
          ? <div className="OpeningHours__NotePremium">
              <UI.tooltip
                value="Upgrade App to describe regular events that happen during your business hours. These will appear in your business hours table."
              >
                <UI.symbol
                  name="premiumLarge"
                  style={{ cursor: 'pointer' }}
                  onClick={openBillingPage}
                />
              </UI.tooltip>
            </div>
          : null}

        <TextInput
          value={note}
          title="Note"
          placeholder="e.g. Happy Hour from 6pm"
          infoText={
            isPremium()
              ? 'Add a note to describe regular events that happen during your business hours. These will appear in your business hours table.'
              : null
          }
          maxLength={50}
          invalidMessage="Limit reached"
          validator={val => (val || '').length < 50}
          onChange={onNoteChange}
          disabled={!isPremium()}
        />
      </div>

      <TimeRanges onChange={onTimerangesChange} timeranges={timeranges} />
    </div>
  );
}

export default OpeningHours;



// WEBPACK FOOTER //
// ./src/commons/components/OpeningHours.jsx